$(document).ready(function() {
    // When a radio input is changed, if it is being displayed as part of a button group, update the button states for the group
    $(document).on('change', '.btn input[type=radio], .btn input[type=checkbox]', function() {
        var name = $(this).attr('name');
        $.each($("[name='" + name + "']"), function() {
            $(this).is(':checked')
                ? $(this).closest('.btn').addClass('active')
                : $(this).closest('.btn').removeClass('active');
        });
    });

    // Trigger the radio-button script once on page load to show pre-selected values
    $('.btn input[type=radio], .btn input[type=checkbox]').trigger('change');
});